import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { IconButton, SvgIcon, Tooltip, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBookFont } from "@fortawesome/pro-light-svg-icons";

/** Top-nav button to the client glossary (ADR-0068), as HelpButton is to help. */
export const GlossaryButton = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Tooltip title={t("client.glossary")}>
      <IconButton
        onClick={() => navigate("/glossary")}
        aria-label={t("client.glossary")}
        data-testid="glossary-nav-button"
        sx={{
          backgroundColor: pathname.startsWith("/glossary")
            ? alpha(theme.palette.common.white, 0.1)
            : "transparent",
        }}
      >
        <SvgIcon>
          <FontAwesomeIcon color="white" icon={faBookFont} />
        </SvgIcon>
      </IconButton>
    </Tooltip>
  );
};
